let initialState = {
  type: null,
  message: null,
  complete: false,
  buttonUrl: null,
  buttonText: null,
  heading: null,
  icon: null,
};

export function modal(state = initialState, action) {
  switch (action.type) {
    case "SHOW_MODAL":
      return {
        ...state,
        type: action.modalType,
        message: action.message || null,
        complete: action.complete || false,
        heading: action.heading || null,
        buttonUrl: action.buttonUrl || null,
        buttonText: action.buttonText || null,
        icon: action.icon || null,
      };
    case "HIDE_MODAL":
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal.js